export default {
  title: 'You can close this window',
  subTitle:
    ' We noticed you using Waitless in another browser window. You can close this window, or re-scan a QR code to visit again.',
  openCameraButton: 'open camera',
};
